/*
 *  Document   : candidate-mission-basic-show.js
 *  Author     : Exapoint
 *
 */

// Import global dependencies

// Import required modules

// Tools
import ExaHelpers from "../exa_helpers";

export default class CandidateMissionBasicShow {

    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["CandidateMissionBasicShow"] = this;
        this.init();
    }

    /*
     * Updates the color theme
     *
     */
    init() {
        this.markersArray = [];
        ExaHelpers.addScript(
            'https://maps.googleapis.com/maps/api/js?libraries=places&callback=Function.prototype&key=' + googleMapsApiKey,
            function () {
                this.initMap();
                this.initDirectionsMap();
            }.bind(this)
        );

        this.latInput = $('[name="lat"]');
        this.lngInput = $('[name="lng"]');

        var swal = Swal.mixin({
            buttonsStyling: !1,
            customClass: {
                confirmButton: "btn btn-success m-1",
                cancelButton: "btn btn-danger m-1",
                input: "form-control"
            }
        });

        let $updateStatusForm = $('.match-update-status-buttons form');

        $updateStatusForm.on('submit', function (e) {
            e.preventDefault();
        });

        $updateStatusForm.find('[type="submit"].js-swal-confirm').on('click', function (e) {
            e.preventDefault();
            let $form = $(e.target).parents('form');

            swal.fire({
                title: jsVars.confirmActionTitle,
                text: jsVars.confirm_delete_text,
                icon: "warning",
                showCancelButton: !0,
                customClass: {confirmButton: "btn btn-danger m-1", cancelButton: "btn btn-secondary m-1"},
                confirmButtonText: jsVars.confirmButtonText,
                cancelButtonText: jsVars.cancelButtonText,
                html: !1,
                preConfirm: function (e) {
                    return ExaHelpers.submitAjaxFormWithButtons($form);
                }.bind(this)
            }).then((function (n) {
                n.value ?
                    swal.fire(jsVars.confirmActionSuccess, '', "success") :
                    "cancel" === n.dismiss
            }))

        }.bind(this));

        $updateStatusForm.find('[type="submit"]:not(.js-swal-confirm)').on('click', function (e) {
            e.preventDefault();
            let $form = $(e.target).parents('form');

            return ExaHelpers.submitAjaxFormWithButtons($form);
        }.bind(this));

        this.initDropzone();
    }

    initDirectionsMap() {
        if (!jsVars.candidateLocation.lat) {
            // Don't load directions map if the address is not set
            return;
        }

        this.directionsService = new google.maps.DirectionsService();
        this.directionsRenderer = new google.maps.DirectionsRenderer();
        var map = new google.maps.Map(document.getElementById('directions-map'), {
            zoom: 13,
            center: {lat: jsVars.candidateLocation.lat, lng: jsVars.candidateLocation.lng}

        });
        this.directionsRenderer.setMap(map);

        this.autocompleteFrom = new google.maps.places.Autocomplete(
            document.getElementById('autocomplete-from'), {
                types: ['address'],
                region: 'EU',
                strictBounds: true,
                fields: ['geometry'],
            }
        );
        this.autocompleteFrom.addListener('place_changed', this.calculateAndDisplayRoute.bind(this));

        this.autocompleteTo = new google.maps.places.Autocomplete(
            document.getElementById('autocomplete-to'), {
                types: ['address'],
                region: 'EU',
                strictBounds: true,
                fields: ['geometry'],
            }
        );
        this.autocompleteTo.addListener('place_changed', this.calculateAndDisplayRoute.bind(this));

        $('#candidate-show-google-route-modal').on('show.bs.modal', function (e) {
            this.calculateAndDisplayRoute();
        }.bind(this));
    }

    calculateAndDisplayRoute() {
        let originPlaceId, destinationPlaceId = false;

        if (this.autocompleteFrom.getPlace()) {
            originPlaceId = this.autocompleteFrom.getPlace().geometry.location;
        } else if (jsVars.candidateLocation) {
            originPlaceId = new google.maps.LatLng(jsVars.candidateLocation.lat, jsVars.candidateLocation.lng);
        }

        if (this.autocompleteTo.getPlace()) {
            destinationPlaceId = this.autocompleteTo.getPlace().geometry.location;
        } else if (jsVars.missionLocation) {
            destinationPlaceId = new google.maps.LatLng(jsVars.missionLocation.lat, jsVars.missionLocation.lng);
        }

        if (!originPlaceId || !destinationPlaceId) {
            return;
        }

        this.directionsService.route(
            {
                origin: originPlaceId,
                destination: destinationPlaceId,
                travelMode: 'DRIVING',
                drivingOptions: {
                    departureTime: new Date(Date.now()),
                    trafficModel: 'optimistic',
                }
            },
            function (response, status) {
                if (status === 'OK') {
                    setTimeout(function () {
                        this.directionsRenderer.setDirections(response);

                        if (response.routes && response.routes["0"] && response.routes["0"].legs["0"]) {
                            $('.directions-estimation .distance-value').html(response.routes["0"].legs["0"].distance.text);
                        }
                    }.bind(this), 100);
                } else {
                    console.log('Directions request failed due to ' + status);
                }
            }.bind(this));
    }

    initMap() {
        this.map = new google.maps.Map(document.getElementById('map'), {
            zoom: 17
        });

        this.showOnMap(parseFloat(this.latInput.val()), parseFloat(this.lngInput.val()));
    }


    showOnMap(geoLat, geoLng) {
        let myLatLng = {lat: geoLat, lng: geoLng};

        let marker = new google.maps.Marker({
            position: myLatLng,
            map: this.map,
        });

        this.clearOverlays();
        this.markersArray.push(marker);
        this.showOverlays();

        this.map.panTo(myLatLng);
    }

    getAddressComponentByType(addressComponents, addressType, property) {
        let result = '';
        if (addressComponents) {
            addressComponents.forEach(function (element) {
                if (element['types'].indexOf(addressType) !== -1) {
                    result = element[property];
                    return false;
                }
            });
        }
        return result;
    }

    // Removes the overlays from the map, but keeps them in the array
    clearOverlays() {
        if (this.markersArray) {
            for (let i in this.markersArray) {
                this.markersArray[i].setMap(null);
            }
        }
        this.markersArray = [];
    }

    // Shows any overlays currently in the array
    showOverlays() {
        if (this.markersArray) {
            for (let i in this.markersArray) {
                this.markersArray[i].setMap(this.map);
            }
        }
    }

    updateLatLngInputs(latLng) {
        this.latInput.val(latLng.lat);
        this.lngInput.val(latLng.lng);
    }

    initDropzone() {
        let $missionFiles = $('#mission-files-dropzone');
        $missionFiles.addClass('dropzone');
        $missionFiles.dropzone(
            {
                url: Laravel.app_url,
                init: function () {
                    let thisDropzone = this;
                    let $thisElement = $(thisDropzone.element);

                    thisDropzone.inputField = $thisElement.find('input');
                    thisDropzone.modelId = $thisElement.parents('.modal').find('[name="id"]').val();
                    thisDropzone.modelId = typeof thisDropzone.modelId === "undefined" ? '' : thisDropzone.modelId;

                    thisDropzone.preloadedFiles = [];
                    if (thisDropzone.inputField.length !== 0) {
                        thisDropzone.preloadedFiles = thisDropzone.inputField.val();
                        thisDropzone.preloadedFiles = JSON.parse(thisDropzone.preloadedFiles);
                    }

                    $.each(thisDropzone.preloadedFiles, function (key, value) {
                        if (!value) {
                            return;
                        }
                        let file = {
                            processing: true,
                            accepted: true,
                            name: value.originalName,
                            size: value.size,
                            type: value.mimeType,
                            status: Dropzone.SUCCESS,
                            downloadLink: value.path,
                            dbData: value,
                        };
                        thisDropzone.files.push(file);
                        thisDropzone.emit("addedfile", file);
                        if (value.thumbnail) {
                            thisDropzone.emit("thumbnail", file, Laravel.app_url + value.thumbnail);
                        }
                        thisDropzone.emit("processing", file);
                        thisDropzone.emit("success", file, {status: "success"}, false);
                        thisDropzone.emit("complete", file);
                        file.path = value.path;
                    });

                    $thisElement.on('click', '[data-dz-name]', function (e) {
                        let $target = $(e.target);
                        let $fileContainer = $target.parents('.dz-preview');
                        let downloadLink = $fileContainer.find('.dz-file-download-link').val();

                        window.open(Laravel.app_url + '/storage/' + downloadLink, '_blank');
                    });

                    this.removeEventListeners();
                },
                sending: function (file, xhr, formData) {
                    return false;
                },
                success: function (file, response) {
                    if (typeof response.uploadedFile !== "undefined") {
                        // This is an ajax response
                        file.path = response.uploadedFile.path;
                        file.dbData = response.uploadedFile;
                        this.inputField.val(JSON.stringify(this.files.map(a => a.dbData)));
                    }
                    let link = file.downloadLink || file.path;
                    if (link) {
                        // Save download link to hidden input for click to open to work
                        file.previewTemplate.insertAdjacentHTML('beforeend',
                            `<input type="hidden" class="dz-file-download-link" value="${link}" />`);
                    }
                    if (typeof response.uploadedFile !== "undefined") {
                        $(file.previewElement).addClass("dz-success");
                        setTimeout(function () {
                            $(file.previewElement).removeClass("dz-success");
                        }, 2750);
                    }
                },
                error: function (file, message) {
                    return false;
                },
            }
        );
    }
}
